import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteMembership } from '../../../../_global/fragments/generated/CompleteMembership';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type RestoreMembershipMutationVariables = Types.Exact<{
  input: Types.RestoreMembershipInput;
  locale?: Types.InputMaybe<Types.SupportedLocale>;
}>;


export type RestoreMembershipMutation = { __typename?: 'Mutation', restoreMembership?: { __typename?: 'RestoreMembershipPayload', membership?: { __typename?: 'Membership', id: string, type: string, accountUser?: { __typename?: 'AccountUser', accountUserType?: Types.AccountUserTypeEnum | null, avatarColor?: Types.AvatarColor | null, email?: string | null, id: string, inviteEmailAddress?: string | null, isPending: boolean, name?: string | null, profileImageUrl?: string | null, userId?: string | null, licenseType?: Types.AccountUserLicenseTypeValue | null } | null, accountUserGroup?: { __typename?: 'AccountUserGroup', accountId: string, emoji?: string | null, id: string, memberCount?: number | null, name?: string | null } | null, role?: { __typename?: 'Role', description?: string | null, id: string, name: string, order?: number | null } | null } | null } | null };


export const RestoreMembership = /*#__PURE__*/ gql`
    mutation RestoreMembership($input: RestoreMembershipInput!, $locale: SupportedLocale) {
  restoreMembership(input: $input) {
    membership {
      ...CompleteMembership
    }
  }
}
    ${CompleteMembership}` as unknown as DocumentNode<RestoreMembershipMutation, RestoreMembershipMutationVariables>;

          

          export const useRestoreMembershipMutation = (options?:MutationHookOptions<RestoreMembershipMutation, RestoreMembershipMutationVariables>) => useMutation(RestoreMembership, options);
          

          export type RestoreMembershipMutationOptions = MutationHookOptions<RestoreMembershipMutation, RestoreMembershipMutationVariables>;

          

          export type RestoreMembershipMutationResult = ReturnType<typeof useRestoreMembershipMutation>[1];

          
